import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * 旧「数据流向地图」（L1-L4 闭环，5 月的旧链路）已下线；旧链接（含 #field-evidence-* 锚点）一律跳到 Plan 的链路总览。
 */
export const Route = createFileRoute("/data-flow-map")({
	beforeLoad: () => {
		throw redirect({ to: "/plan-lab", hash: "overview" });
	},
});
